<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="clockinRecord">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            打卡记录列表
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                    <!-- <el-button type="primary" plain @click.native="toggleModalAdd">导出</el-button> -->

                    <div style="float:right">
                        <el-input  placeholder="请输入姓名" v-model="searchBuild" clearable @change="getList" class="search"></el-input>
                         <el-select v-model="userType" clearable  placeholder="用户类型" class="search">
                            <el-option
                            v-for="item in userTypeValue"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-select v-model="status" clearable  placeholder="打卡状态" class="search">
                            <el-option
                            v-for="item in statusValue"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                         <el-select v-model="clockinPointCode" clearable  placeholder="请选择地点" class="search">
                            <el-option
                            v-for="item in clockinPointValue"
                            :key="item.clockinPointCode"
                            :label="item.name"
                            :value="item.clockinPointCode">
                            </el-option>
                        </el-select>
                        <el-date-picker
                            v-model="startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="开始日期" class="search">
                        </el-date-picker>
                        <el-date-picker
                            v-model="endTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="结束日期" class="search">
                        </el-date-picker>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" border style="width: 100%;">


                        <el-table-column prop="user.name" label="姓名"></el-table-column>
                        <el-table-column prop="user.userType" label="用户类型">
                            <template slot-scope="scorp">
                                <span v-if="scorp.row.user.userType==3">医生</span>
                                <span v-if="scorp.row.user.userType==4">护士</span>
                                <span v-if="scorp.row.user.userType==5">护工</span>
                                <span v-if="scorp.row.user.userType==6">员工</span>
                                <span v-if="scorp.row.user.userType==7">保安</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="user.departmentName" label="部门"></el-table-column>
                        <el-table-column prop="status" label="打卡状态">
                            <template slot-scope="scorp">
                                <span v-if="scorp.row.status==1">正常</span>
                                <span v-if="scorp.row.status==2">迟到</span>
                                <span v-if="scorp.row.status==3">缺卡</span>
                                <span v-if="scorp.row.status==4">早退</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="clockinPlanItem.clockinTime" :formatter="formatterTime1" label="规定打卡时间"></el-table-column>
                        <el-table-column prop="createTime" :formatter="formatterTime1" label="实际打卡时间"></el-table-column>
                        <el-table-column prop="address" label="打卡地点"></el-table-column>
                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

    </div>
</template>

<script>

    import {timeStr,getBeforeDate} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,

                showModalAdd:false,
                showModalEdit:false,
                searchBuild:'',
                clockinPointCode:"",
                clockinPointValue:[],
                userType:-1,
                status:-1,
                startTime:getBeforeDate(-30),
                endTime:getBeforeDate(0),
                userTypeValue:[{
                    value:-1,
                    label:"全部用户类型"
                },{
                    value:3,
                    label:"医生"
                },{
                    value:4,
                    label:"护士"
                },{
                    value:5,
                    label:"护工"
                },{
                    value:6,
                    label:"员工"
                },{
                    value:7,
                    label:"保安"
                },],
                statusValue:[{
                    value:-1,
                    label:"全部状态"
                },{
                    value:1,
                    label:"正常"
                },{
                    value:2,
                    label:"迟到"
                },{
                    value:3,
                    label:"缺卡"
                },{
                    value:4,
                    label:"早退"
                }],
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,

                th:0,

            }
        },
        created(){
            this.getList();
            this.getClockinPointList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            formatterTime1(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,19):null
            },
            getList(){

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"ClockinRecord/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        status:this.status,
                        name:this.searchBuild,
                        userType:this.userType,
                        clockinPointCode:this.clockinPointCode,
                        startTime:this.startTime,
                        endTime:this.endTime,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getClockinPointList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"ClockinPoint/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.clockinPointValue = response.data.data;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            }


        }
    }
</script>

<style lang="scss" scoped>
    .clockinRecord .search{
        margin:0 10px;
        width:200px
    }
</style>
